
export default function Services() {
  const services = [
    {
      icon: 'ri-ship-line',
      title: 'Renta de Lanchas',
      description: 'Contamos con una amplia variedad de lanchas para todo tipo de ocasiones. Desde lanchas deportivas hasta lanchas familiares, todas equipadas con lo necesario para tu comodidad y seguridad.'
    },
    {
      icon: 'ri-sailboat-line',
      title: 'Renta de Yates',
      description: 'Experimenta el lujo en el mar con nuestros yates de primera clase. Perfectos para eventos especiales, celebraciones o simplemente para disfrutar de un día inolvidable en el océano.'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Capitán Incluido',
      description: 'Todos nuestros servicios incluyen un capitán profesional certificado con amplia experiencia en las aguas de Veracruz. Tu seguridad es nuestra prioridad.'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Reservas Flexibles',
      description: 'Ofrecemos opciones de renta por hora, medio día o día completo. Adaptamos nuestros servicios a tus necesidades y presupuesto para que disfrutes al máximo.'
    },
    {
      icon: 'ri-fish-line',
      title: 'Tours de Pesca',
      description: 'Disfruta de la pesca deportiva en las mejores zonas de Veracruz. Incluimos equipo de pesca profesional y guía experto para una experiencia única.'
    },
    {
      icon: 'ri-goblet-line',
      title: 'Eventos Especiales',
      description: 'Celebra tus momentos especiales en el mar. Bodas, cumpleaños, aniversarios o eventos corporativos. Personalizamos cada detalle para hacer tu evento memorable.'
    }
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nuestros Servicios
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Ofrecemos servicios completos de renta de embarcaciones con todo incluido para tu tranquilidad
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:-translate-y-2"
            >
              <div className="w-16 h-16 bg-teal-500 rounded-xl flex items-center justify-center mb-6">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
